import * as yup from 'yup';
import { UnitsEnum } from '../apiConstants';
import { CropTypes } from './variety';

export enum UserRolesEnum {
  root = 'root',
  admin = 'admin',
  viewer = 'viewer',
  qa = 'qa',
}

export const RoleSchema = yup.object().shape({
  id: yup.number(),
  name: yup
    .string()
    .oneOf(Object.values(UserRolesEnum), 'Invalid role')
    .required('Role name is required'),
  resourceID: yup.string().required('Resource ID (customerID) is required'),
  userID: yup.string().required('User ID is required'),
});

export type Role = yup.InferType<typeof RoleSchema>;

export const UserSettingsSchema = yup.object().shape({
  language: yup.string().default('en'),
  units: yup
    .string()
    .oneOf(Object.values(UnitsEnum))
    .default(UnitsEnum.imperial),
  onboardingComplete: yup.bool().default(false),
  cropTypes: yup
    .array()
    .of(yup.string().oneOf(Object.values(CropTypes)))
    .default([]),
});

export type UserSettings = yup.InferType<typeof UserSettingsSchema>;

export const UserSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  customerID: yup.string().required('Customer ID is required'),
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  roles: yup
    .array()
    .of(RoleSchema)
    .required('Roles are required')
    .min(1, 'At least one role is required'),
  settings: UserSettingsSchema.nullable(),
});

export type User = yup.InferType<typeof UserSchema>;
